"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slideOut = exports.slideIn = void 0; // -------------------------------------------
//   ANIMATIONS > SLIDE
// -------------------------------------------
// (((((((((( ~~~~~~~~~~ SLIDE IN ~~~~~~~~~~ )))))))))) //

var slideIn = {
  // ***** SLIDE IN : DOWN ***** //
  '@keyframes slideInDown': {
    from: {
      transform: 'translate3d(0, -100%, 0)',
      visibility: 'visible'
    },
    to: {
      transform: 'translate3d(0, 0, 0)'
    }
  },
  // ***** SLIDE IN : LEFT ***** //
  '@keyframes slideInLeft': {
    from: {
      transform: 'translate3d(-100%, 0, 0)',
      visibility: 'visible'
    },
    to: {
      transform: 'translate3d(0, 0, 0)'
    }
  },
  // ***** SLIDE IN : RIGHT ***** //
  '@keyframes slideInRight': {
    from: {
      transform: 'translate3d(100%, 0, 0)',
      visibility: 'visible'
    },
    to: {
      transform: 'translate3d(0, 0, 0)'
    }
  },
  // ***** SLIDE IN : UP ***** //
  '@keyframes slideInUp': {
    from: {
      transform: 'translate3d(0, 100%, 0)',
      visibility: 'visible'
    },
    to: {
      transform: 'translate3d(0, 0, 0)'
    }
  }
}; // (((((((((( ~~~~~~~~~~ SLIDE OUT ~~~~~~~~~~ )))))))))) //

exports.slideIn = slideIn;
var slideOut = {
  // ***** SLIDE OUT : DOWN ***** //
  '@keyframes slideOutDown': {
    from: {
      transform: 'translate3d(0, 0, 0)'
    },
    to: {
      transform: 'translate3d(0, 100%, 0)',
      visibility: 'hidden'
    }
  },
  // ***** SLIDE OUT : LEFT ***** //
  '@keyframes slideOutLeft': {
    from: {
      transform: 'translate3d(0, 0, 0)'
    },
    to: {
      transform: 'translate3d(-100%, 0, 0)',
      visibility: 'hidden'
    }
  },
  // ***** SLIDE OUT : RIGHT ***** //
  '@keyframes slideOutRight': {
    from: {
      transform: 'translate3d(0, 0, 0)'
    },
    to: {
      transform: 'translate3d(100%, 0, 0)',
      visibility: 'hidden'
    }
  },
  // ***** SLIDE OUT : UP ***** //
  '@keyframes slideOutUp': {
    from: {
      transform: 'translate3d(0, 0, 0)'
    },
    to: {
      transform: 'translate3d(0, -100%, 0)',
      visibility: 'hidden'
    }
  }
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

exports.slideOut = slideOut;